import axios from "fetch-api/fetch-api";
import PASentry from "../../util/pa-sentry";

export function getYearByMakeModel(make: string, model: string) {
  if (make && model) {
    return axios.get<string[]>("/get-years-by-make-model-v3", {
      params: {
        make,
        model,
      },
    });
  }
  const error = new Error("make && model not present in get-years-by-make-model-v3");
  PASentry.logException(error, {}, { });
  return Promise.reject(error);
}
